module.exports = __webpack_public_path__ + "87dc9bda3f2cdc04bc277f453442a5a0.glb";